import { Flex } from '@chakra-ui/react';
import { L3_PATHS } from 'Deer/constants/routes';
import { useQuery } from 'components/hooks/useQuery';
import { useHistory, useParams } from 'react-router-dom';

import { ArrowBack } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { TextHeader2 } from 'uiToolkitV1/Typography';

import { CompensationDetails } from './components/CompensationDetails';
import { CompensationEmployeeDetails } from './components/CompensationEmployeeDetails';
import { CompensationHistory } from './components/CompensationHistory';
import { CompensationOverview } from './components/CompensationOverview';

export const CompensationRecommendation = () => {
  const { employeeId } = useParams<{ employeeId: string }>();
  const { source } = useQuery();
  const history = useHistory();

  console.log('employeeId', employeeId);

  const handleBack = () => {
    if (source === 'company') {
      history.push(L3_PATHS.company.compensation.planning);
    } else {
      history.push(L3_PATHS.team.allReports.compensation.planning);
    }
  };

  return (
    <Flex flexDir="column" gap="12px" mt="8px">
      <PaperWithShadow w="100%" p="12px">
        <Flex alignItems="center">
          <Button
            StartIcon={ArrowBack}
            variant="tertiary"
            iconSize="24px"
            startIconProps={{ color: 'var(--chakra-colors-text-g2) !important' }}
            onClick={handleBack}
          />
          <TextHeader2 bold mr="12px">
            Compensation recommendations
          </TextHeader2>
        </Flex>
      </PaperWithShadow>
      <PaperWithShadow p="0">
        <Flex flexDir="column" gap="8px" my="16px" mx="12px" p="8px" bg="neutral.F5F7F9" borderRadius="8px">
          <CompensationDetails />
          <CompensationOverview />
          <CompensationHistory />
          <CompensationEmployeeDetails />
        </Flex>
        <Flex
          p="16px"
          justifyContent="space-between"
          alignItems="center"
          bg="surface.F5F7F9"
          borderTop="1px solid"
          borderColor="border.CFD7DF"
          borderBottomRadius="8px"
        >
          <Button variant="outlined">Cancel</Button>
          <Button>Submit</Button>
        </Flex>
      </PaperWithShadow>
    </Flex>
  );
};
